// extracted by mini-css-extract-plugin
export default {"noDataContainer":"NoDataFound_noDataContainer__64dUR"};